import { computed, type ComputedRef } from 'vue'
import { useUserStore } from '@/store/user'
import { UserRole } from '@/types/roles'

const FINNECTO_GROUP = 'Finnecto'
const FINNECTO_EMAIL_SUFFIX = '@finnecto.com'

export interface UserAccess {
  isStaff: ComputedRef<boolean>
  isInFinnectoGroup: ComputedRef<boolean>
  isFinnectoEmail: ComputedRef<boolean>
  isFinnectoMember: ComputedRef<boolean>
  isSuperAdmin: ComputedRef<boolean>
}

export function useUserAccess(): UserAccess {
  const userStore = useUserStore()
  const isInFinnectoGroup = computed(() => (userStore.cognitoGroups ?? []).includes(FINNECTO_GROUP))
  const isFinnectoEmail = computed(() => (userStore.email ?? '').toLowerCase().endsWith(FINNECTO_EMAIL_SUFFIX))
  return {
    isStaff: computed(() => userStore.role === UserRole.STAFF),
    isInFinnectoGroup,
    isFinnectoEmail,
    isFinnectoMember: computed(() => isInFinnectoGroup.value || isFinnectoEmail.value),
    isSuperAdmin: computed(() => userStore.role === UserRole.SUPER_ADMIN),
  }
}
